export default "__VITE_ASSET__7r_rlR8h__"